// extracted by mini-css-extract-plugin
module.exports = {"youtube":"Footer_youtube__2i7W2","facebook":"Footer_facebook__2Wq6F","twitter":"Footer_twitter__2_gyD","Mobile":"Footer_Mobile__1l49Y","HvrGrow":"Footer_HvrGrow__2U9JC"};